import {
  mockGetAmlIndividualKeyParties,
  AmlKeyPartyIndividualResults,
  mockGetAmlScreenKeyPartiesResults,
  generateKeyPartiesDatasets,
  mockGetAmlBusinessKeyParties,
  AmlBusinessResults,
  mockGetKeyPartiesIndividualAmlSearchHits,
  AmlIndividualSearchHitResults,
  AmlBusinessSearchHitResults,
  mockGetKeyPartiesBusinessAmlSearchHits,
  mockUpdateKeyPartiesIndividualAmlSearchHits,
  mockUpdateKeyPartiesBusinessAmlSearchHits,
  mockGetAmlBusinessKeyUbos,
  mockGetUbosBusinessAmlSearchHits,
  mockGetAmlIndividualUbos,
  mockGetUbosIndividualAmlSearchHits,
  mockGetKeyPartiesResults,
  generateDataForKeyParties,
  mockDownloadBusinessHitReport,
  mockDownloadIndividualHitReport,
} from "../api/aml";

import {
  mockDeleteFromMonitoring,
  mockGetMonitoringSchedules,
  mockSaveAMLSearchHitNote,
  mockUpdateMonitoring,
  MonitoringDetailsByIdDataBuilder,
  AmlSearchesIdDataBuilder,
  mockGetAmlSearches,
  mockAddNewKeyPartyBulk,
  mockGetUboDetails,
  GenerateUboDetailsResponse,
  mockGetKeyPartiesByProfile,
  keyPartiesData,
  mockUpdateKeyParty,
  mockDeleteKeyParty,
  mockGetProfileDetails,
} from "../api/profile";
import { mockGetRechargeSummary } from "../api/recharge";
import {
  mockGetSanctionBodies,
  mockGetPreferences,
} from "../api/settings/mocks/settings-mock-api";
import { mockGetUsersRoles } from "../api/user/user-roles-mock-api";
import { mockEnableAuthorizationFeatureFlag } from "../api/user/user-mock-api";
import { searchApiTypes, searchTypes } from "../modules/aml/aml.constant";
import {
  mockGetRolePermissions,
  mockGetRolesPermissionsList,
  mockPutRolePermissions,
} from "../api/permissions/permissions-mock-api";

// Mock data size constants
const LARGE_DATASET_SIZE = 56;
const MEDIUM_DATASET_SIZE = 30;
const SMALL_DATASET_SIZE = 23;
const MINI_DATASET_SIZE = 14;
const TINY_DATASET_SIZE = 12;
const SUPPLIER_HIT_ID =
  "d6a8a38005256d3efb698a2719f1d9001276809e67e6fdfbf93d3afbb50f3db5:714145";

export const handlers = [
  mockEnableAuthorizationFeatureFlag(),
  mockUpdateMonitoring(MonitoringDetailsByIdDataBuilder()),
  mockDeleteFromMonitoring(),
  mockGetMonitoringSchedules(MonitoringDetailsByIdDataBuilder()),
  mockGetAmlSearches(
    searchApiTypes.individual,
    AmlSearchesIdDataBuilder(searchTypes.individual)
  ),
  mockGetAmlSearches(
    searchApiTypes.business,
    AmlSearchesIdDataBuilder(searchTypes.business)
  ),
  mockGetAmlScreenKeyPartiesResults(
    generateKeyPartiesDatasets(LARGE_DATASET_SIZE)
  ),
  mockGetKeyPartiesResults(generateDataForKeyParties(LARGE_DATASET_SIZE)),
  mockAddNewKeyPartyBulk(),
  mockSaveAMLSearchHitNote(),
  mockGetAmlIndividualKeyParties(
    AmlKeyPartyIndividualResults(TINY_DATASET_SIZE)
  ),
  mockGetUboDetails(GenerateUboDetailsResponse(MEDIUM_DATASET_SIZE)),
  mockGetAmlIndividualUbos(AmlKeyPartyIndividualResults(TINY_DATASET_SIZE)),
  mockGetAmlBusinessKeyParties(AmlBusinessResults(MINI_DATASET_SIZE)),
  mockGetKeyPartiesByProfile("123456789", keyPartiesData),
  mockGetKeyPartiesIndividualAmlSearchHits(
    AmlIndividualSearchHitResults(SMALL_DATASET_SIZE)
  ),
  mockGetKeyPartiesBusinessAmlSearchHits(
    AmlBusinessSearchHitResults(SMALL_DATASET_SIZE)
  ),
  mockUpdateKeyPartiesIndividualAmlSearchHits(),
  mockUpdateKeyPartiesBusinessAmlSearchHits(),
  mockGetAmlBusinessKeyUbos(AmlBusinessResults(MINI_DATASET_SIZE)),
  mockUpdateKeyParty(keyPartiesData[0]),
  mockDeleteKeyParty(),
  mockGetUbosBusinessAmlSearchHits(
    AmlBusinessSearchHitResults(SMALL_DATASET_SIZE)
  ),
  mockGetUbosIndividualAmlSearchHits(
    AmlIndividualSearchHitResults(SMALL_DATASET_SIZE)
  ),
  mockGetProfileDetails(),

  mockDownloadBusinessHitReport(SUPPLIER_HIT_ID),
  mockDownloadIndividualHitReport(SUPPLIER_HIT_ID),
  mockGetRechargeSummary(),
  mockGetSanctionBodies,
  mockGetPreferences({}),
  mockGetUsersRoles(),
  mockGetRolesPermissionsList(),
  mockGetRolePermissions(),
  mockPutRolePermissions(),
];
